import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";

function Disclaimer() {
    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            width: '100%',
            // overflow: 'hidden'
        }}>

        <Header />
            <div style={{ display: 'flex', flexDirection: window.innerWidth > 575 ? 'row' : 'column', marginTop: window.innerWidth > 575 ? '140px' : '72px', marginLeft: window.innerWidth > 575 ? '46px' : '24px', textAlign: 'left', minHeight: window.innerWidth > 575 ? '69vh' : '50vh'}}>
                <div style={{flex: 1}}></div>
                <div style={{flex: 1, textAlign: 'left'}}>
                    <div style={{width: window.innerWidth > 575 ? '65%' : '90%'}}>
                        <p style={{fontWeight: 600, textTransform: 'uppercase'}}>Disclaimer</p>
                        <p>Disclaimer Vinimark Trading (Pty) Ltd is a company registered in South Africa. Registration number: 1987/000032/07 Registered Address : 5Herold Street, Stellenbosch, Western Cape, 7600, South Africa. This message (and any associated files) is intended only for the use of the individual or entity to which it is addressed and may contain information that is confidential, subject to copyright or constitutes a trade secret. If you are not the intended recipient you are hereby notified that any dissemination, copying or distribution of this message, or files associated with this </p>
                        <p>Messages sent to and from us may be monitored. Internet communications cannot be guaranteed to be secure or error-free as information could be intercepted, corrupted, lost, destroyed, arrive late or incomplete, or contain viruses. Therefore, we do not accept responsibility for any errors or omissions that are present in this message, or any attachment, that have arisen as a result of e-mail transmission. If verification is required, please request a hard-copy version. Any views or opinions presented are solely those of the author and do not necessarily represent those of the company.</p>
                    </div>

                </div>
            </div>
            <Footer />
        </div>


    )
}

export default Disclaimer;
